import React from 'react';
import PropTypes from 'prop-types';
import { SFSurveysTenantLanguage } from "utils/types";
import Footer from 'common/Footer';
import ConfirmDialog from 'common/ConfirmDialog';
import StyledButton from 'common/StyledButton';
import Icon from 'SF/MaterialIcon';
import { hideSaveDraftButton } from 'utils/surveys';

export default class SurveyFooter extends React.Component {

  constructor() {
    super();
    this.state = {
      isConfirmResetDialogOpen: false,
      isConfirmSubmitDialogOpen: false,
    };
  }

  closeResetDialog = () => this.setState({ isConfirmResetDialogOpen: false });

  closeSubmitDialog = () => this.setState({ isConfirmSubmitDialogOpen: false });

  get confirmResetDialog() {
    return (
      <ConfirmDialog
        isOpen={this.state.isConfirmResetDialogOpen}
        onClose={this.closeResetDialog}
        confirmText="Reset"
        headerText={`Are you sure you want to reset this ${this.props.progressSurveyWords.singular.survey}?`}
        descriptionText={`You will not be able to recover any changes you made to this ${this.props.progressSurveyWords.singular.survey}.`}
        onConfirm={() => {
          this.props.onResetSurvey();
          this.closeResetDialog();
        }}
      />
    );
  }

  get confirmSubmitDialog() {
    let progressSurveyWord = this.props.progressSurveyWords.singular.survey;
    return (
      <ConfirmDialog
        isOpen={this.state.isConfirmSubmitDialogOpen}
        onClose={this.closeSubmitDialog}
        confirmText="Submit"
        headerText={this.props.isSurveyUnchanged 
          ? <>You haven&apos;t made any changes to this {progressSurveyWord}.</>
          : <>Are you sure you want to submit this {progressSurveyWord} for <b><u>ALL</u></b> students in this section?</>
        }
        descriptionText={this.props.isSurveyUnchanged 
          ? <>Are you sure you want to submit this {progressSurveyWord} for <b><u>ALL</u></b> students in this section? You will not be able to view or edit this {progressSurveyWord} after you submit it.</>
          : <>You will not be able to view or edit this {progressSurveyWord} after you submit it. It may take a few hours for these items to appear on each student&apos;s record.</>
        }
        onConfirm={() => {
          this.props.onSubmitSurvey();
          this.closeSubmitDialog();
        }}
      />
    );
  }

  onSubmitClick = () => {
    this.props.canSubmit 
      ? this.setState({isConfirmSubmitDialogOpen: true})
      : this.props.forceValidation();
  }

  get submitText() {
    return this.props.isCurrentlySubmitting ? "Submitting..." : "Submit"
  }

  render() {
    return (
      <>
        <Footer
          primaryButton={
            <StyledButton disabled={!this.props.canClickOnSubmit} onClick={this.onSubmitClick}>
              {this.submitText}
            </StyledButton>
          }
          secondaryButton={
            <StyledButton asLink onClick={() => this.setState({isConfirmResetDialogOpen: true})}>
              <span><Icon icon='refresh' aria-hidden='true'/>Reset</span>
            </StyledButton>
          }
          optionalMiddleButton={
            hideSaveDraftButton() 
            ? null
            : (
              <StyledButton asLink onClick={this.props.onSaveDraft} disabled={!this.props.canSaveDraft}>
                <span><Icon icon='save' aria-hidden='true'/>Save</span>
              </StyledButton>
            )
          }
        />
        {this.confirmResetDialog}
        {this.confirmSubmitDialog}
      </>
    );
  }
}

SurveyFooter.propTypes = {
  onSubmitSurvey: PropTypes.func.isRequired,
  onResetSurvey: PropTypes.func.isRequired,
  canClickOnSubmit: PropTypes.bool.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  onSaveDraft: PropTypes.func.isRequired,
  forceValidation: PropTypes.func.isRequired,
  canSaveDraft: PropTypes.bool.isRequired,
  isSurveyUnchanged: PropTypes.bool.isRequired,
  progressSurveyWords: SFSurveysTenantLanguage,
  isCurrentlySubmitting: PropTypes.bool.isRequired
};
